import React from "react";
import { motion } from "framer-motion";

const AIAvatarSubmission = ({ handleConfirmAvatarCreation }) => {
  return (
    <motion.div
      className="flex items-center justify-center w-[50vw] max-w-[600px] mx-auto"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.6 }}
    >
      <div className="w-full text-center p-6">
        {/* Success Icon with Decorations */}
        <div className="relative flex justify-center mb-4">
          {/* Main Checkmark Icon */}
          <motion.div
            className="bg-green-100 rounded-full p-4 z-10"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ type: "spring", stiffness: 260, damping: 10 }}
          >
            <svg
              className="h-8 w-8 text-green-600"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M5 13l4 4L19 7"
              />
            </svg>
          </motion.div>
        </div>

        {/* Title */}
        <h1 className="text-[3vh] font-semibold text-[#202020]">
          Your AI Avatar
          <br />
          Submission Is Complete!
        </h1>

        {/* Subtitle */}
        <p className="text-sm text-[#484848] mt-2 text-[2vh]">
          Our Quality Team Will Verify Your Footage (Typically Within 24 Hours).
          <br />
          We'll Email You If Adjustments Are Needed
        </p>

        {/* Note Box */}
        <div className="bg-[#F5F5F5] border border-purple-200 text-[#202020] text-[2vh] mt-6 p-4 rounded-lg text-sm leading-relaxed">
          <p>
            A representative will contact you via email/phone within 1 business
            day to{" "}
            <strong className="font-semibold text-black">
              Confirm final pricing (₹5,000)
            </strong>{" "}
            and share secure payment options
          </p>
          <p className="mt-2">
            You will receive your AI avatar files within 3–5 business days after
            payment
          </p>
        </div>

        {/* Button */}
        <motion.button
          className="mt-6 px-6 py-2 text-[2vh] bg-indigo-600 hover:bg-indigo-700 text-[#fff] rounded-lg"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          onClick={handleConfirmAvatarCreation}
        >
          Okay
        </motion.button>
      </div>
    </motion.div>
  );
};

export default AIAvatarSubmission;
